import React, { useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { TeamResource } from '~~apis/resource';
import TeamHeader from './TeamHeader';
import PermissionList from './PermissionList';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding-top: 2rem;

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const permissionTooltipMapping = {
  ADMIN: '可進行所有操作，至少需有一位管理者',
  EDITOR: '不得修改管理者權限',
  VIEWER: '僅提供瀏覽管理資訊，不得做任何修改',
};

const TeamPermission = ({ userInfo, teams, reload }) => {
  const [teamIndex, setTeamIndex] = useState(0);
  const updatePermission = ({ userUniqid, targetUniqid, authority }) => {
    return TeamResource.updatePermission({ userUniqid, teamUniqid: targetUniqid, authority });
  };

  return (
    <StyledDiv>
      {teams.length > 0 && <TeamHeader teams={teams} teamIndex={teamIndex} setTeamIndex={setTeamIndex} />}
      <PermissionList
        userInfo={userInfo}
        target={teams[teamIndex]}
        updatePermission={updatePermission}
        reload={reload}
        permissionTooltipMapping={permissionTooltipMapping}
      />
    </StyledDiv>
  );
};

export default TeamPermission;
